var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "password-settings" },
    [
      _c(
        "sui-form",
        [
          _c(
            "sui-grid",
            { attrs: { centered: "" } },
            [
              _c(
                "sui-grid-row",
                [
                  _c(
                    "sui-grid-column",
                    { attrs: { centered: "", width: "six" } },
                    [
                      _c(
                        "sui-header",
                        { tag: "h2", staticClass: "password-form-header" },
                        [_vm._v(" Change password ")]
                      ),
                      _c("sui-form-field", [
                        _c("label", [_vm._v("Current password")]),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.password.current_password,
                              expression: "password.current_password",
                            },
                          ],
                          attrs: {
                            type: "password",
                            placeholder: "Enter your current password",
                            autocomplete: "off",
                          },
                          domProps: { value: _vm.password.current_password },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(
                                _vm.password,
                                "current_password",
                                $event.target.value
                              )
                            },
                          },
                        }),
                      ]),
                      _c("sui-form-field", [
                        _c("label", [_vm._v("New password")]),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.password.new_password,
                              expression: "password.new_password",
                            },
                          ],
                          attrs: {
                            type: "password",
                            placeholder: "Enter new password",
                            autocomplete: "off",
                          },
                          domProps: { value: _vm.password.new_password },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(
                                _vm.password,
                                "new_password",
                                $event.target.value
                              )
                            },
                          },
                        }),
                      ]),
                      _c("sui-form-field", [
                        _c("label", [_vm._v("Confirm new password")]),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.password.new_password_confirmation,
                              expression: "password.new_password_confirmation",
                            },
                          ],
                          attrs: {
                            type: "password",
                            placeholder: "Confirm new password",
                            autocomplete: "off",
                          },
                          domProps: {
                            value: _vm.password.new_password_confirmation,
                          },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(
                                _vm.password,
                                "new_password_confirmation",
                                $event.target.value
                              )
                            },
                          },
                        }),
                      ]),
                      _c("sui-button", {
                        attrs: {
                          type: "button",
                          basic: "",
                          content: "Change password",
                          color: "blue",
                          size: "small",
                        },
                        on: { click: _vm.save },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }